import React from 'react';
import ContentContainer from './ContentContainer';
import './PageHeader.css';

function PageHeader({ title, intro, className = '' }) {
  return (
    <ContentContainer className={`page-header ${className}`}>
      {title && <h1 className="page-title">{title}</h1>}
      {intro && <p className="page-intro">{intro}</p>}
    </ContentContainer>
  );
}

export default PageHeader;

